"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iCreateTRMVRMeterEntryRemark = exports.iTRMVRMeterEntryRemark = void 0;
const t = require("io-ts");
const User = require("./user");
const file_1 = require("./file");
const _iTRMVRMeterEntryRemark = t.partial({
    id: t.number,
    uuid: t.string,
    entry_uuid: t.string,
    created_by: t.union([t.number, User.iUser]),
    confirmed_by: t.union([t.number, User.iUser]),
    meter_type: t.union([t.literal('TRMETER'), t.literal('MVRMETER')]),
    target: t.string,
    remark: t.string,
    responsible_company: t.string,
    must_be_fixed_at: t.union([t.string, t.number]),
    additional_info: t.string,
    confirmed_at: t.union([t.string, t.number]),
    confirmation_comment: t.string,
    created_at: t.union([t.string, t.number]),
    updated_at: t.union([t.string, t.number]),
    image_folder_id: t.number,
    image_folder_uuid: t.string,
    image_folder: file_1.iFolder,
    confirmation_image_folder_id: t.number,
    confirmation_image_folder_uuid: t.string,
    confirmation_image_folder: file_1.iFolder,
    remark_status: t.string,
    entry_date: t.union([t.string, t.number]),
});
exports.iTRMVRMeterEntryRemark = t.clean(_iTRMVRMeterEntryRemark);
// interface + partial on returned data
const _iCreateTRMVRMeterEntryRemark = t.intersection([
    t.interface({
        entry_uuid: t.string,
        created_by: t.union([t.number, User.iUser]),
        meter_type: t.union([t.literal('TRMETER'), t.literal('MVRMETER')])
    }),
    t.partial({
        id: t.number,
        uuid: t.string,
        confirmed_by: t.union([t.number, User.iUser]),
        target: t.string,
        remark: t.string,
        responsible_company: t.string,
        must_be_fixed_at: t.union([t.string, t.number]),
        additional_info: t.string,
        confirmed_at: t.union([t.string, t.number]),
        confirmation_comment: t.string,
        created_at: t.union([t.string, t.number]),
        updated_at: t.union([t.string, t.number]),
        image_folder_id: t.number,
        image_folder_uuid: t.string,
        confirmation_image_folder_id: t.number,
        confirmation_image_folder_uuid: t.string,
        remark_status: t.string,
    })
]);
exports.iCreateTRMVRMeterEntryRemark = t.clean(_iCreateTRMVRMeterEntryRemark);
//# sourceMappingURL=trmvrmeterEntryRemark.js.map